import { useLayoutEffect } from 'react';
import nativeEffect from '../nativeEffect';
export default function useNativeEffect(listener, deps) {
    useLayoutEffect(function () {
        return nativeEffect.connect(listener, !!deps);
    }, deps);
}
